import { render, staticRenderFns } from "./ConversaDetalhes.vue?vue&type=template&id=5ffd636b&scoped=true"
import script from "./ConversaDetalhes.vue?vue&type=script&lang=js"
export * from "./ConversaDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ConversaDetalhes.vue?vue&type=style&index=0&id=5ffd636b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd636b",
  null
  
)

export default component.exports